import React from "react";
import type { MarketValue } from "@bloomberg/octagon-shared";
import SummaryCell from "./SummaryCell";
import styles from "./summaryOverview.module.css";
import {
  formatMoneyWithLeadingPlusOrMinus,
  formatWithCurrencyCommasAndDecimals,
} from "~utils/portfolio/formatNumber";

type SummaryOverviewProps = {
  marketValue?: MarketValue;
  currency?: string;
  isLoading?: boolean;
};

export default function SummaryOverview(props: Readonly<SummaryOverviewProps>) {
  const { marketValue, currency, isLoading = false } = props;

  return (
    <div className={styles.summaryOverview}>
      <div className={styles.summaryRowChange}>
        <SummaryCell
          title="Total Gain / Loss"
          value={marketValue?.totalGainLoss}
          percentChange={marketValue?.totalGainLossPercentChange}
          currency={currency}
          formatter={formatMoneyWithLeadingPlusOrMinus}
          variant="with-change"
          isLoading={isLoading}
        />
        <SummaryCell
          title="Day Gain / Loss"
          value={marketValue?.todayGainLoss}
          percentChange={marketValue?.todayGainLossPercentChange}
          formatter={formatMoneyWithLeadingPlusOrMinus}
          variant="with-change"
          isLoading={isLoading}
        />
      </div>
      <div className={styles.summaryRow}>
        <SummaryCell
          title="Value"
          value={marketValue?.value}
          formatter={formatWithCurrencyCommasAndDecimals}
          isLoading={isLoading}
        />
        <SummaryCell
          title="Cost"
          value={marketValue?.cost}
          formatter={formatWithCurrencyCommasAndDecimals}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}
